__turbopack_context__.v({
  "checked": "LinkPill-module__SYFHVq__checked",
  "main": "LinkPill-module__SYFHVq__main",
});
